const { UPLOAD_DESIGN, UPLOAD_DESIGN_SUCCESS, UPLOAD_DESIGN_FAIL, GET_DESIGN, GET_DESIGN_SUCCESS, GET_DESIGN_FAIL, DELETE_DESIGN, DELETE_DESIGN_SUCCESS, DELETE_DESIGN_FAIL } = require("./Constants");

const initialState = {
    designList: [],
    successMsg: "",
    errors: "",
    Loading: false
}

const ManageMarketingToolsReducer = (state = initialState, action) => {
    switch (action.type) {
        case UPLOAD_DESIGN:

            return {
                ...state,
                successMsg: "",
                errors: "",
                Loading: true
            }
        case UPLOAD_DESIGN_SUCCESS:
            return {
                ...state,
                successMsg: action.payload,
                Loading: false
            }
        case UPLOAD_DESIGN_FAIL:
            return {
                ...state,
                errors: action.payload,
                Loading: false
            }
        case GET_DESIGN:
            return{
                ...state,
                errors:"",
                successMsg:"",
                Loading: true
            }
        case GET_DESIGN_SUCCESS:
            return{
                ...state,
                designList: action.payload,
                Loading: false
            }
        case GET_DESIGN_FAIL:
            return{
                ...state,
                errors: action.payload,
                Loading: false
            }
        case DELETE_DESIGN:
            return{
                ...state,
                Loading: true,
                errors: "",
                successMsg: ""
            }
        case DELETE_DESIGN_SUCCESS:
            return{
                ...state,
                Loading: false,
                successMsg: action.payload
            }
        case DELETE_DESIGN_FAIL:
            return{
                ...state,
                Loading: false,
                errors: action.payload
            }
        default:
            return state
    }
}

export default ManageMarketingToolsReducer;